import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function AddNoteModal({ isOpen, onClose, onSubmit, deliveryName }) {
  const [note, setNote] = useState('');

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (note.trim()) {
      onSubmit(note.trim());
      setNote('');
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleSubmit();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-locate2-border-light">
          <h3 className="text-lg font-semibold text-locate2-dark-blue">Add Note</h3>
          <button
            onClick={onClose}
            className="text-locate2-light-gray hover:text-locate2-medium-gray transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4">
          <p className="text-locate2-light-gray text-sm mb-3">
            Adding note for:{' '}
            <span className="font-medium text-locate2-medium-gray">{deliveryName}</span>
          </p>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter your note here..."
            className="w-full h-32 p-3 border border-locate2-border rounded-lg text-locate2-medium-gray placeholder:text-locate2-light-gray focus:outline-none focus:border-locate2-primary focus:ring-1 focus:ring-locate2-primary resize-none"
            autoFocus
          />
          <p className="text-locate2-light-gray text-xs mt-2">
            Press Ctrl+Enter to submit
          </p>
        </div>
        <div className="flex gap-3 p-4 border-t border-locate2-border-light">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 border border-locate2-border rounded-lg text-locate2-medium-gray font-medium hover:bg-locate2-bg-light transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!note.trim()}
            className="flex-1 px-4 py-2.5 bg-locate2-primary rounded-lg text-white font-medium hover:bg-locate2-dark-blue transition-colors disabled:bg-locate2-disabled disabled:cursor-not-allowed"
          >
            Add Note
          </button>
        </div>
      </div>
    </div>
  );
}
